export default "__VITE_ASSET__rPkzN8DL__"